import styled, { keyframes } from 'styled-components';
import { palette, Button } from '@m12s/component-library';

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px 40px;
  gap: 24px;
`;

export const DisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  gap: 24px;
  max-width: 320px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.005em;
  color: ${palette.Grey700};
  font-family: 'Noto Sans', sans-serif;
  padding: 0 16px;
  margin: 0;
`;

export const PinIndicatorsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 14px;
  margin-top: 12px;
`;

export const PinDot = styled.div`
  width: 14px;
  min-width: 14px;
  height: 14px;
  border-radius: 8px;
  background-color: ${palette.Grey700};
`;

export const ErrorText = styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.004em;
  color: ${palette.Red500};
  opacity: ${(props) => {
    return props.$visible ? 1 : 0;
  }};
  height: 20px;
  min-width: 200px;
  font-family: 'Noto Sans', sans-serif;
  margin: 0;
`;

export const KeyboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 288px;
`;

export const KeyboardRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 288px;
  height: 80px;
`;

export const NumberButton = styled.button`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 1px solid ${palette.Grey200};
  background: transparent;
  font-size: 28px;
  font-weight: 600;
  color: ${palette.Grey700};
  font-family: 'Noto Sans', sans-serif;
  line-height: 100%;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: ${palette.Grey100};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionButton = styled(NumberButton)`
  font-size: 16px;
`;

export const BackspaceButton = styled(NumberButton)`
  font-size: 24px;
  font-weight: 400;
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 288px;
`;

export const SubmitButton = styled(Button)`
  width: 288px;
  height: 96px;
  border-radius: 16px;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  font-family: 'Noto Sans', sans-serif;
`;

export const SecondaryButton = styled(Button)`
  width: 288px;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Noto Sans', sans-serif;
`;

// Success view styles
export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 24px;
`;

const checkmarkAnimation = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const SuccessCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-color: ${palette.Green500};
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${checkmarkAnimation} 0.3s ease-out;
`;

export const SuccessText = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: ${palette.Grey700};
  font-family: 'Noto Sans', sans-serif;
  margin: 0;
`;

export const IconWrapper = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: 0;
  padding: 8px;
  margin: 0;
  cursor: pointer;
`;

export const LoadingSpinner = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid ${palette.White};
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const WarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 24px;
`;

export const WarningCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-color: ${(props) => {
    return props.$required ? palette.Red500 : palette.Yellow500;
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
`;

export const WarningTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: ${palette.Grey700};
  font-family: 'Noto Sans', sans-serif;
  text-align: center;
  margin: 0;
`;

export const WarningMessage = styled.p`
  font-size: 16px;
  text-align: center;
  color: ${palette.Grey700};
  font-family: 'Noto Sans', sans-serif;
  line-height: 20px;
  margin: 0;
`;

export const WarningButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 288px;
`;

export const BackButton = styled(Button)`
  width: 288px;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Noto Sans', sans-serif;
`;
